export interface IInfrastructure {
  type: EInfrastructureType;
  text: string;
}

export enum EInfrastructureType {
  /** Детские площадки **/
  Children = 'children',
  /** Коммерческие объекты **/
  Commerce = 'commerce',
  /** Площадки для выгула собак **/
  Dogs = 'dogs',
  /** Пункты бытового обслуживания **/
  Domestic = 'domestic',
  /** Фитнес-центр **/
  Fitness = 'fitness',
  /** Детский сад **/
  Kindergarten = 'kindergarten',
  /** Офисы **/
  Offices = 'offices',
  /** Поликлиника **/
  Polyclinic = 'polyclinic',
  /** Бассейн **/
  Pool = 'pool',
  /** Места для отдыха **/
  Recreation = 'recreation',
  /** Рестораны **/
  Restaurant = 'restaurant',
  /** Школа **/
  School = 'school',
  /** SPA-центо **/
  Spa = 'spa',
  /** Спортивные площадки **/
  Sport = 'sport',
  /** Супермаркет **/
  Supermarket = 'supermarket',
}
